import { render, staticRenderFns } from "./PlanSettingsUsers.vue?vue&type=template&id=5617b7d0"
import script from "./PlanSettingsUsers.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports